export const SPONSORS_ACTIONS = {
    SET_SPONSORS: "SET_SPONSORS",
    SET_IS_LOADING: "SET_IS_LOADING",
}